module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"Username":"ユーザー名","FirstName":"名","LastName":"姓","PhoneNumber":"電話番号","Email":"メールアドレス","LastSeen":"最終閲覧","Stores":"店舗","Actions":"編集","user_management":" ユーザー管理","addUser":"追加","confirmDelete":"確認","promptDelete":"ユーザーを削除しますか？","successMessage":"ユーザーは更新されました。","updateMessage":"ユーザーは更新されました。","deleteMessage":"ユーザーは正常に削除されました。"}}')
  delete Component.options._Ctor
}
